import { Paper as MUIPaper, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomPaper = styled(MUIPaper)(({ variant, theme }) => {
    return {
        borderRadius: '16px',
        padding: theme.spacing(5),
        ...(variant === 'outlined' && {
            border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        }),
    };
});

const Paper = forwardRef((props, ref) => {
    return <CustomPaper ref={ref} {...props} />;
});

export default Paper;
